import { NavRoute, NavWithSubRoutes } from '@shared/components';
import { useContentRoutes } from './useContentRoutes';
import { useSanityRoute } from './useSanityRoute';

export const useNavRoutes = (): (NavRoute | NavWithSubRoutes)[] => {
  const staticRoutes = useContentRoutes();
  const sanityRoute = useSanityRoute();
  return [...staticRoutes, sanityRoute].filter((route) => !!route) as (
    | NavRoute
    | NavWithSubRoutes
  )[];
};
